import { routes } from '~/constants/routes';

export const isPublicRoute = (pathname: string): boolean => {
  if (pathname === routes.login) {
    return true;
  }
  if (
    pathname.startsWith(routes.invitation) ||
    pathname.startsWith(routes.verifyEmail)
  ) {
    return true;
  }
  return false;
};
